// Change 8: Prefs renamed to Search.
// This file keeps the old /app/prefs route alive and immediately redirects
// to /app/search so any bookmarks or existing links don't 404.
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/app/prefs")({
  beforeLoad: () => {
    throw redirect({ to: "/app/search", replace: true });
  },
  component: () => null,
});
